export default {
    STATUS: {
        INIT: 'INIT',
        READY: 'READY',
        UPLOADING: 'UPLOADING',
        SUCCESS: 'SUCCESS',
        COMPLETE: 'COMPLETE',
        ERROR: 'ERROR',
        CANCELLED: 'CANCELLED'
    },
    RESULT: {
        NORMAL: 0,
        TYPE_ERROR: 1,
        SIZE_ERROR: 2,
        IFRAME_TIMEOUT: 3,
        SERVER_ERROR: 4
    }
};
